var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '../../../utils/styled-components';
import StyledErrorIcon from '../../../Notification/icons/Error';
var Error = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n  color: ", ";\n  font-size: ", ";\n  display: flex;\n  align-items: center;\n"], ["\n  margin-top: ", ";\n  color: ", ";\n  font-size: ", ";\n  display: flex;\n  align-items: center;\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.error.margin;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.textColor.error;
}, function (_a) {
    var component = _a.theme.component;
    return component.form.fontSize.small;
});
export var ErrorMessage = function (_a) {
    var className = _a.className, error = _a.error;
    if (error) {
        return (React.createElement(Error, { className: className, "data-testid": "input-error-message-text" },
            React.createElement(StyledErrorIcon, null),
            error));
    }
    return null;
};
export default ErrorMessage;
var templateObject_1;
//# sourceMappingURL=index.js.map